import './App.css';
import Footer from './components/Footer';
import Navigation from './components/Navigation';
import Payment from './components/Payment';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Dashboard from './components/bangashpanel/Dashboard';
import Products from './components/bangashpanel/products/Products';
import Categories from './components/bangashpanel/categories/Categories';
import Insight from './components/bangashpanel/insights/Insight';
import PaymentSuccessfulPage from './components/PaymentSuccessfulPage';
import TopDonators from './components/bangashpanel/top-donators/TopDonators';


function App() {
  return (
    <>
      <Navigation />
      <BrowserRouter basename='/store'>
        <Routes>
          <Route path="/" element={<Payment />} />
          <Route path="/payment-successful" element={<PaymentSuccessfulPage />} />
          <Route path="bangashpanel" element={<Dashboard />} />
          <Route path="bangashpanel/products" element={<Products />} />
          <Route path="bangashpanel/categories" element={<Categories />} />
          <Route path="bangashpanel/insights" element={<Insight />} />
          <Route path="bangashpanel/top-donators" element={<TopDonators />} />
        </Routes>
      </BrowserRouter>
      <Footer />
    </>
  );
}

export default App;
